import { v4 as uuidv4 } from 'uuid';
import DateHelper from "./date-helper";

export class UserDataHelper {
	static setUUID() {
		const cookie = costorage.get('h_uuid');

		if (cookie) {
			return;
		}

		const uuid = uuidv4();
		costorage.set('h_uuid', uuid, { expires: DateHelper.getOneYearInSeconds() * 2, path: '/', domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua' });
	}

	static getUUID() {
		let cookie = costorage.get('h_uuid');

		if (!cookie) {
			UserDataHelper.setUUID();
			cookie = costorage.get('h_uuid');
		}

		return cookie;
	}

	static getCID() {
		let match = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)');

		const raw = (match) ? decodeURIComponent(match[1]) : null;

		if (raw) {
			match = raw.match(/(\d+\.\d+)$/);
		}

		const gacid = (match) ? match[1] : null;

		if (gacid) {
			return gacid;
		}
	}
}